import React from "react";

import AppBar from "../Landing/AppBar";
import Integrations from "../Landing/Integrations";
import Cart from "./Cart";
import JoinUs from "../Landing/JoinUs";

function PresentationPricing() {
  return (
    <React.Fragment>
      <AppBar />
      <Cart />
    </React.Fragment>
  );
}

export default PresentationPricing;
